<template>
  <div class="container--sign-up text-center">
    <div @click="goBack" class="back-button">&#8592; <Translate directive="profile.backlabel" /></div>
    <div class="text-center">
      <p class="step-indicator"><Translate directive="forgotpassword.instructions" /></p>
      <h3><Translate directive="forgotpassword.title" /></h3>
    </div>
    <b-form @submit="submit">
      <b-form-group
          id="input-group-1"
          label="Email address:"
          label-for="input-1">
          <b-form-input
          id="input-1"
          class="forgot-pass"
          :style="{'--primaryColor': settings.primaryColor ? settings.primaryColor.hex : ''}"
          v-model="form.email"
          type="email"
          required
          :placeholder="this.$_polyglot.t('forgotpassword.email.placeholder')"
          ></b-form-input>
      </b-form-group>
      <BaseButton type="submit" class="button sign-in-email" :style="{'background-color': settings.primaryColor ? settings.primaryColor.hex : '', '--button-color': `${settings.primaryColor.hex}`, '--button-hover': `${settings.primaryColor.hex}`}"><b-spinner v-show="loading" small type="grow"></b-spinner><span v-show="!loading"><Translate directive="forgotpassword.button" /></span></BaseButton>
    </b-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Translate from './translate'
export default {
  components: {
    Translate
  },
  data () {
    return {
      loading: false,
      error: '',
      form: {
        email: ''
      }
    }
  },
  created () {
    this.$bvModal.hide('modal-login')
  },
  computed: mapState(['home', 'settings']),
  methods: {
    goBack () {
      this.$bvModal.hide('modal-forgotpw')
      this.$bvModal.show('modal-login')
    },
    async submit (evt) {
      evt.preventDefault()
      this.error = ''
      this.loading = true
      const response = await this.$store.dispatch('forgotPassword', this.form.email)
      if (response.data.success) {
        // Logged in
        this.$bvModal.hide('modal-forgotpw')
        this.loading = false
      } else {
        this.error = response.data.message
        this.loading = false
      }
    }
  }
}
</script>

<style lang='scss' scoped>
  .forgot-pass {
    &:focus {
      border: 1px solid var(--primaryColor);
    }
  }
</style>
